export const data = [
  {
    id: 1,
    title: "Lake Como, Italy",
    desc: "ake Como has been a popular retreat for aristocrats and wealthy people since Roman times, and a very popular tourist attraction with many artistic and cultural gems. It has many villas and palaces such as Villa Olmo, Villa Serbelloni, and Villa Carlotta. Many famous people have had and have homes on the shores of Lake Como.",
    image:
      "https://i0.wp.com/handluggageonly.co.uk/wp-content/uploads/2021/03/HandLuggageOnly-14-2.jpg?w=1600&ssl=1",
  },
  {
    id: 2,
    title: "Mykonos, Greece",
    desc: "Mykonos has been known as the island of the winds, and it’s located in the heart of the Cyclades group. Mykonos ticks all three. It was one of the first of the Greek islands to be considered a holiday destination and has been popular since the 60s.",
    image:
      "https://i.pinimg.com/originals/c4/1a/60/c41a608980e089dbccf712261b50dedc.jpg",
  },
  {
    id: 3,
    title: "Dubrovnik, Crotia",
    desc: "Dubrovnik (derived from dubrava in Croatian, meaning “grove”) occupies a promontory jutting into the sea under the bare limestone mass of Mount Srdj. The port’s sea fortifications rise directly from the water’s edge, and the massive round tower (completed 1464) of the Minc̆eta Fortress dominates the city on the landward side.",
    image:
      "https://images.hola.com/imagenes/viajes/20200407165155/dubrovnik-croacia-maravillas-desde-mi-pantalla/0-808-901/dubrovnik-playa-a.jpg",
  },
  {
    id: 4,
    title: "Petra, Jordan",
    desc: "The city of Petra, capital of the Nabataean Arabs, is one of the most famous archaeological sites in the world, it is Located 240 km south of the capital Amman and 120 km north of the red sea town of Aqaba (see the Map), Petra the world wonder, is undoubtedly Jordan's most valuable treasure and greatest tourist attraction, and it is visited by tourists from all over the world.",
    image:
      "https://i.pinimg.com/originals/ae/87/fb/ae87fbdc00aedd484c1f188d9b4ab2fb.jpg",
  },
  {
    id: 5,
    title: "Montana, Wyoming",
    desc: "One of the main attraction to see is the Leshan Grand Buddha. The Grand Buddha is a 71 meter (230 feet) high sculpture carved into one of the large cliffs by the river. Back in the 8th century, Hai Tong led the charge to carve the Leshan Giant Buddha out of a cliff face. The result was a 71-meter Buddha statue that is both the tallest and largest in the world.",
    image:
      "https://localadventurer.com/wp-content/uploads/2019/02/yellowstone-things-to-do.jpg",
  },
  {
    id: 6,
    title: "Anse Source d'Argent, Seychelles",
    desc: "The absolutely breathtaking scenery is the real highlight of Anse Source d’Argent. The mixture of shallow, clear water, golden sand, and imposing granite formations make it one of the most picturesque beaches anywhere in the world, and one that’s well worth visiting for anyone taking a holiday to the Seychelles.",
    image:
      "https://i0.wp.com/jyoshankar.com/wp-content/uploads/2021/06/jyoshankar_ladigue_ansesourcedargent_seychelles_13.jpg?resize=768%2C960&ssl=1",
  },
  {
    id: 7,
    title: "Ha Long Bay, Vietnam",
    desc: "Towering limestone pillars and tiny islets topped by forest rise from the emerald waters of the Gulf of Tonkin. Designated a World Heritage Site in 1994, Halong Bay's scatter of islands, dotted with wind- and wave-eroded grottoes, is a vision of ethereal beauty and, unsurprisingly, northern Vietnam's number one-tourism hub.",
    image:
      "https://i.pinimg.com/564x/50/02/e7/5002e7de0415aa117055420b5fec58a4.jpg",
  },
  {
    id: 8,
    title: "The Dead Sea, Israel",
    desc: "The Dead Sea, known in Hebrew as Yam Ha-Melakh (the Sea of Salt) is the lowest point on earth. It’s surrounded by the stunning landscape of the Negev Desert. The shores of the Dead Sea are the lowest point on the surface of the earth. The saline waters of the lake means no fish can survive in the salty waters, hence the name. The other result of the salty water is their renowned health and healing properties of the mud. ",
    image:
      "https://images.squarespace-cdn.com/content/v1/596b2969d2b85786e6892853/1559658551705-B1QHWLY2HKBHCEBIQ8L1/Things+to+do+in+the+Dead+Sea+-+The+Dead+Sea+Tree?format=750w",
  },
  {
    id: 9,
    title: "Machu Picchu, Peru",
    desc: "Every year, millions of people visit the imposing and mysterious Incan citadel of Machu Picchu in Peru. But getting to the massive agricultural terraces, intricate stone constructions, and epic hilltop views of this UNESCO World Heritage site isn't cheap, and it involves some trickier-than-usual logistics. Here's how to expertly navigate your way to Peru's most famous destination.",
    image:
      "https://i0.wp.com/handluggageonly.co.uk/wp-content/uploads/2017/05/IMG_2968-s.jpg?w=1600&ssl=1",
  },
  {
    id: 10,
    title: "Mont Saint Michel, France",
    desc: "Initially founded by a hermit from Ireland, this medieval town is characterized by intricate architecture and curvy streets and is most known for having one of France’s best attractions, the Mont Saint Michel Abbey. Started in the 10th century, this Benedictine abbey is a great example of Gothic and Romanesque architecture, and it was one of the first UNESCO World Heritage Sites.",
    image:
      "https://www.lifesavvy.com/p/uploads/2021/03/eff9dad9.jpg?width=1200",
  },
  {
    id: 11,
    title: "Mostar, Bosnia & Herzegovina",
    desc: "Mainly known for the Old Bridge, or Stari Most, there’s so much more to Mostar. Other than the smells of delicious cuisine and the sounds of traditional live music, there are several popular sites to see that include the remains of Cim Early Christian Basilica, Bishop’s Ordinariate, and the Tara and Halebija Towers. Well-deserving of the honor of being among Europe’s best cities,",
    image:
      "https://www.roadaffair.com/wp-content/uploads/2017/09/mostar-bosnia-shutterstock_291941039.jpg",
  },
  {
    id: 12,
    title: "Los Cabos, Mexico",
    desc: "Flanked by the Pacific Ocean and the Gulf of California, Los Cabos' symphony of natural features — desert, mountains, sea, and plenty of sunshine — and yes, raucous party scene, have made it one of the most popular vacation destinations in North America. Its cobalt blue waters are a hub for diving, snorkeling, kayaking, fishing, and whale watching.",
    image:
      "https://i1.wp.com/nextwithnita.com/wp-content/uploads/2018/05/IMG_4795-3.jpg?w=1080&ssl=1",
  },
];

export default data;